import Konva from "konva";
import React from "react";

import { usePermanent } from "~/tools/use-permanent";

import { Container, type ContainerConfig } from "./Container";

export type LayerConfig = ContainerConfig;

export type LayerProps = LayerConfig;

export const Layer: React.FC<React.PropsWithChildren<LayerProps>> = ({ children, ...config }) => {
	const layer = usePermanent(() => new Konva.Layer(config));

	return (
		<Container instance={layer} {...config}>
			{children}
		</Container>
	);
};
